  <!-- Community list -->
  <h4 class="heading-4 py-3" *ngIf="dss.user_community_list.length">
    {{mls.languageText.create_post_community.key3}}
  </h4>
  <ng-container *ngIf="dss.user_community_list.length">
    <label class="post-modal-community-list-card p-3 w-100 d-flex align-items-center justify-content-between"
      *ngFor="let commList of dss.user_community_list">
      <div class="float-left d-flex align-items-center">
        <span class="float-left rounded mr-2">
          <img alt="pic" class="card-56 rounded-circle" [src]="commList?.media_list[0]?.media_url"
            onerror="this.src='assets/images/community.webp'">
        </span>
        <span class="float-left">
          <span class="heading-4">
            {{commList?.title}}
          </span>
        </span>
      </div>
      <div class="float-right mb-3">
        <!-- checkbox -->
        <div class="checkbox">
          <input type="checkbox"
            [checked]="commList?.checked" (click)="addCommunity($event, commList)" value="{{commList?.id}}">
          <span></span>
        </div>
      </div>
    </label>
    <div *ngIf="view_more_community_flag" class="secondary-paragraph-bold  text-center" (click)="showMoreCommunity()">
      <span class="paragraph-bold cursor-pointer pr-2">{{mls.languageText.create_post_community.key4}}
        {{mls.languageText.create_post_community.key5}}<img src="assets/themes/icons/down-arrow.svg"  alt="down arrow" />
      </span>
    </div>
    <!--end Community list-->
    </ng-container>